import { User } from '.../../../domain/entities/user';
import { fetchUserUseCase } from './fetch-user';
import words from '../../../constants/words';

export type fetchSubscriberInPageUseCase = (id: string) => Promise<User>;

export const buildFetchSubscriberInPage = (dependencies: {
  userInteractor: {
    fetchUser: fetchUserUseCase;
  };
}): fetchSubscriberInPageUseCase => {
  const {
    userInteractor: { fetchUser },
  } = dependencies;

  const fetchSubscriberInPage: fetchSubscriberInPageUseCase = async (id) => {
    try {
      if (!id) {
        throw new Error(words.somethingWentWrong);
      }
      const user = (await fetchUser({ id })) as User;

      if (!user) {
        throw new Error(words.somethingWentWrong);
      }

      return user;
    } catch (error) {
      throw error;
    }
  };

  return fetchSubscriberInPage;
};
